import styled from 'styled-components';

const StyledFileName = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default StyledFileName;
